export class Agent {
  id: number;
  name: string;
  brandName: string;
  code: string;
  location: string;
  locationMain: string;
  email: string;
  phone: string;
  slogan: string;
  imageLogo: string;
  imageLogoBase64: string;
  website: string;
  facebook: string;
  twitter: string;
  pluraloUrl: string;
  address: string;
  zip: string;
  place: string;
  vat: string;
  agentSize: number;
  salesChannel: object;
  accountCertificationType: number;
  bookPermission: boolean;
  country: {
    id: number;
    code2: string;
    name: string;
    dial: string;
    code: string;
    default: boolean
  };
  contacts: string[];
  commission: {
    defaultCommission: number;
    commissionRelations: string[];
  };
  salesStore: boolean;
  salesWebsite: boolean;
  salesHotel: boolean;
  currency: string;
  timezone: string;
  role: string;
  by: string;
  stripeApiKey_Public: string;
  stripeApiKey_Secret: string;
  ticketType: number; // 0 - POS, 1 - A4.
}



// WEBPACK FOOTER //
// ./src/app/shared/api/model/agent.ts